export default "__VITE_ASSET__625e0209__"